<template>
  <footer class="grid-container">
    <div class="padding-bottom-m padding-top-m small grid-x align-justify text-center">
      <div>
        <a
          :href="`${CXO_PRODUCTION_CS_DOMAIN}/articles/highlights-of-${footerBrandValue.privacyNotice}-notice-of-privacy-practices`"
          class="padding-right-xs"
        >Privacy Notice</a>
        <a
          :href="`${CXO_PRODUCTION_CS_DOMAIN}/articles/${footerBrandValue.legalNotice}`"
          class="padding-right-xs padding-left-xs"
        >Legal Notice</a>
        <a
          :href="`${CXO_PRODUCTION_CS_DOMAIN}/articles/${footerBrandValue.interestBasedAds}`
            +`-notice-of-privacy-practices#interest-based-or-online-behavioral-advertising`"
          class="padding-right-xs padding-left-xs"
        >Interest Based Ads</a>
        <a
          :href="`${CXO_PRODUCTION_CS_DOMAIN}/category/shipping-delivery?cm_sp=navigation`+
            `-_-bottom_nav-_-shipping_%26_delivery&lid=glbbtmnav_shipping_%26_delivery-us`"
          class="padding-right-xs padding-left-xs"
        >Shipping Policy</a>
        <a
          :href="`${CXO_PRODUCTION_CS_DOMAIN}/category/returns?cm_sp=navigation-_-bottom_nav-_-returns&lid=glbbtmnav_returns-us`"
          class="padding-left-xs"
        >Return Policy</a>
      </div>
      <p>
        &copy; {{ currentYear }} {{ footerBrandValue.copyright }}
      </p>
    </div>
  </footer>
</template>
<script setup>
import { CXO_PRODUCTION_CS_DOMAIN } from 'config';

const footerBrandValue = process.env.ENTRY_POINT === 'mcom' ? {
  copyright: 'Macy\'s. All rights reserved. Macys.com, LLC, 151 West 34th Street, New York, NY 10001',
  privacyNotice: 'macys-inc',
  interestBasedAds: 'macys-and-macyscom',
  legalNotice: 'legal-notice',
} : {
  copyright: 'Bloomingdale\'s. 1000 Third Avenue New York, NY 10022',
  privacyNotice: 'bloomingdales',
  interestBasedAds: 'bloomingdales-and-bloomingdalescom',
  legalNotice: 'bloomingdales-terms-of-use',
};

const currentYear = new Date().getFullYear();

</script>
    <style src="./css/common.scss" lang="scss" scoped/>
